export default function()
{
    const self = this;

    /**
     * Whether the filters are locked
     * @type {Boolean}
     */
    self.locked = false;

    /**
     * Set the filters to locked/unlocked
     * @param {Boolean} locked
     */
    self.setLocked = locked => {
        self.locked = locked;
    };

    /**
     * See whether the lock is active
     * @return {Boolean}
     */
    self.isLocked = () => {
        return self.locked;
    };
}



// WEBPACK FOOTER //
// ./resources/js/MrMovie/FiltersLocker.js